/* eslint-disable no-restricted-imports */
import {Form} from 'react-bootstrap';
import type {IHeaderForm} from '../ModalPolicyCreateOrEditXML';

type TProps = {
	form: IHeaderForm;
	onChange: (formState: IHeaderForm) => void;
};

const HeaderForm = ({form, onChange}: TProps) => (
	<div className="row mb-4 bg-white rounded border pb-4 mx-0 pt-2">
		<div className="col-xs-12 col-lg-3">
			<label htmlFor="idname">Name</label>
			<Form.Control
				required
				id="idname"
				name="name"
				placeholder="Name"
				value={form.name}
				onChange={onChange as never}
				aria-label="Name"
				maxLength={255}
			/>
		</div>

		<div className="col-xs-12 col-lg-3">
			<label htmlFor="idpriority">Priority</label>
			<Form.Control
				id="idpriority"
				required
				name="priority"
				placeholder="Priority"
				value={form.priority}
				onChange={onChange as never}
				aria-label="priority"
				type="number"
			/>
		</div>

		<div className="col-xs-12 col-lg-3">
			<label htmlFor="idscope">Scope</label>
			<Form.Control
				id="idscope"
				disabled
				name="scope"
				placeholder="Scope"
				value={form.scope}
				required
				onChange={onChange as never}
				aria-label="scope"
			/>
		</div>

		<div className="col-xs-12 col-lg-3 pt-4">
			<Form.Check
				checked={form.enabled}
				name="enabled"
				type="switch"
				label="Enabled"
				id="custom-switch"
				className="ml-4 mt-2"
				onChange={onChange as never}
			/>
		</div>
	</div>
);

export default HeaderForm;
